/**
 * Bank Entity Service - Pricing Management
 *
 * Handles loan pricing and terms including:
 * - Interest rate management
 * - Fee structures
 * - Pricing analytics
 * - Market rate monitoring
 */

// ====== PRICING SERVICE ======

class BankPricingService {
  private baseUrl = '/api/bank/pricing';
  private useMockApi = import.meta.env.VITE_USE_MOCK_API === 'true';
  private isDevelopment = import.meta.env.DEV || import.meta.env.NODE_ENV === 'development';

  /**
   * Get current rates
   */
  async getCurrentRates(): Promise<unknown> {
    if (this.useMockApi || this.isDevelopment) {
      return this.getMockRates();
    }

    try {
      const response = await fetch(`${this.baseUrl}/rates`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.warn('Pricing API not available, using mock data');
        return this.getMockRates();
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching rates:', error);
      return this.getMockRates();
    }
  }

  private getMockRates(): unknown {
    return {
      baseRate: 4.25,
      communityLendingRate: 4.75,
      lastUpdated: new Date().toISOString(),
      rateSheet: {
        low_risk: 4.25,
        medium_risk: 4.75,
        high_risk: 5.5,
      },
    };
  }
}

export const bankPricingService = new BankPricingService();
